import React, { Component } from 'react';
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import { PootsyTitle } from './DesignFunctions'
import SignUpForm from './SignUpForm'

export default class SignUp extends Component {
	render() {
		let { t } = this.context

		return (
			<div className="SignUp">
				<PootsyTitle title={t('signup_header')}/>
				<div className="signup-prompt">
					{t('signup_prompt')} <Link to="/auth/signin" className="login-link">{t('sign_in')}</Link>
				</div>
				<SignUpForm />
			</div>
		)
	}
}

SignUp.contextTypes = { t: PropTypes.func }


// WEBPACK FOOTER //
// ./src/components/SignUp.js